import { z } from "zod";
import { StatusFilterType } from "../types/statusFilter";

export const createStatusFilterSchema = <TStatus extends z.EnumLike>(
    statuses: TStatus,
) =>
    z.object({
        filterType: z.nativeEnum(StatusFilterType),
        kickStatuses: z.array(z.nativeEnum(statuses)),
        externalStatuses: z.array(z.nativeEnum(statuses)),
    });
